// Generated by scripts/photos-build.mjs. Do not edit.
// Source of truth is photos/manifest.json; run `npm run photos` to refresh.

export interface Photo {
  slug: string
  /** Original pixel dimensions, used to reserve space and avoid layout shift. */
  width: number
  height: number
  date: string
  /** Where it was taken. Empty until labelled in photos/manifest.json. */
  location: string
  caption: string
  /** Inline blur-up placeholder. */
  lqip: string
  /** Content fingerprint, appended to derivative URLs so edits invalidate. */
  v: string
}

/** Widths available as `/photos/<slug>-<width>.webp`. */
export const PHOTO_WIDTHS = [400, 900, 1800] as const

/** In the order set in photos/manifest.json. */
export const photos: Photo[] = [
  {
    slug: '2026-09-04-01',
    width: 6240,
    height: 4160,
    date: '2026-09-04',
    location: 'Canyonlands National Park, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRoQAAABXRUJQVlA4IHgAAAAwBACdASoUAA0APt1cpkyopSOiMAgBEBuJYgCdMoMjbDu5FSL6P3ERQMAAy0cwUQQhED/HSEufPGmwi7UIuMaa4k4ezboHCqOy+t63IGh8CUthEc3JJEugg7mPGFi7wlkK4S9FOFAPv627TN+P2BsxweY5SH5gAAA=',
    v: '3a6022e0ba',
  },
  {
    slug: '2026-08-22-01',
    width: 6240,
    height: 4160,
    date: '2026-08-22',
    location: 'Provo Canyon, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAACwAwCdASoUAA0APt1apkyopSOiMAgBEBuJZwAAUpLT4hIIipbEcAD+w/3t9q4eIylvwofNc5asm443XO5iWAEamav1dcjE6L6ROXz93LPADgK/U/+mhO9EFiUcsIgHfB/AeXjswAA=',
    v: 'd3adee0537',
  },
  {
    slug: '2026-09-06-01',
    width: 6237,
    height: 4158,
    date: '2026-09-06',
    location: 'Canyonlands National Park, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRooAAABXRUJQVlA4IH4AAADQAwCdASoUAA0APt1cpkyopSOiMAgBEBuJQBWABCxcZKMedKFqlkAA/sdl2O7Z9tdLrt2wDDXcMqUrNnwCtEJcmWsV3PU9P005oRVucetK3k6+Yn2EUg80vNpBaAFtf7DR+trMXBfldbK9VkWLbtUQvTmWCHIu/hjQR1TQAAA=',
    v: '6f39b2902b',
  },
  {
    slug: '2026-09-05-01',
    width: 3739,
    height: 5609,
    date: '2026-09-05',
    location: 'Canyonlands National Park, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRuoAAABXRUJQVlA4IN4AAACQBQCdASoUAB4APtlWoUyoJKMiMAwBABsJQBOgBFlLqZ2BXbacYcwPqr+LscOkUW9+7tkfoAD7+SF1/ttrhJlqD73KyLxHRRmLGL5fOwiPM+wfzFQV+cLfo4Bc9AV3aT8FkxZwZhNHWTTs9AvQFC+igxT2v2XX0qZ+Ms2jZ0pMOGubIyGh3BockzAevvrG+wgdLtBXyFGDAo/9hy/tbyp24xYHn0akACVODO/yvqbtsg5vjMDKiGDIcjVipvsQodhPtF6dSQQNdqet1tuO64FZG6mlsTF9jy2PBpugAAA=',
    v: '50733c7ca3',
  },
  {
    slug: '2026-09-12-01',
    width: 3072,
    height: 4080,
    date: '2026-09-12',
    location: 'Salt Lake City, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpwAAABXRUJQVlA4IJAAAAAwBQCdASoUABsAPt1YqE8opKOiMBgIARAbiUATplAANSI5BqUaHzB0iyBvs/Lap/ow0AD+297lD5tUgobi1rtTwaErqudwHR8ZQVMz7kNWOfhqLs/Q83/fcceoO8Cbj/Mm6MyxcgzpPTZOUnx9atlVL3vBKPBv774VdTalmJkGqFFn2i76Wxf6usFkl902AAA=',
    v: '7aa1cdade3',
  },
  {
    slug: '2026-08-29-01',
    width: 5452,
    height: 3635,
    date: '2026-08-29',
    location: 'Wasatch National Forest, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAAAwBACdASoUAA0APt1cpkyopSOiMAgBEBuJYwC7AYvWtn93UFBexmr0YgAA/rYVWXZMwQC+9eoRXz9vzFad2I8hOcnTDL7UWim4X2e570nmjUKdNs3NMnqAyeZ5eItOR9pFG9+oLA6FHqv4IPVnoSZzRV+BxsAHlM9f4/iNVCkpIOYkRT79ShFL1IAAAA==',
    v: '85a79649d3',
  },
  {
    slug: '2026-09-05-03',
    width: 6240,
    height: 4160,
    date: '2026-09-05',
    location: 'Canyonlands National Park, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnwAAABXRUJQVlA4IHAAAAAQBACdASoUAA0APt1apkyopSOiMAgBEBuJQBadMV4cteYN/UdLsfOCAAD+uf64UL6vBfp0TYvuqw84nlsE/IJMq5T7lYDp4aVFr4NdOJSH7pDfJwwaV10DedPBJ8VzcPw31IlysEd5SKs3spt4JoAA',
    v: 'c0f820619c',
  },
  {
    slug: '2026-09-04-02',
    width: 6240,
    height: 4160,
    date: '2026-09-04',
    location: 'Canyonlands National Park, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnoAAABXRUJQVlA4IG4AAACQBACdASoUAA0APt1apkyopSOiMAgBEBuJZACdMoR8lulAKRAqnhNx3SKTjAAA8Y2OrbfeIKc2sYtVj0zeJdyPPQPVFcED5MkjieXgpR9e6/01o6mv4kb+FFqEKrocjFeSabaE4tAC2xyGWSAAAA==',
    v: 'aaac231390',
  },
  {
    slug: '2026-08-21-02',
    width: 6240,
    height: 4160,
    date: '2026-08-21',
    location: 'Nowhere, Nebraska',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRo4AAABXRUJQVlA4IIIAAAAQBACdASoUAA0APt1cpkyopSOiMAgBEBuJQBibMXcb5lYW+pHdvokjAAD+9oZ2WUt5yE5FOl1MIexM84tm+4PXzD9xaYw03f5P61MaxURgpevCLie1OJYRTWbiCUXE07SrA48OBl32nlwRuZ3/EIV8DWZLcRzAL0/iOYkQRzD+zAAA',
    v: 'cb55cd40a4',
  },
  {
    slug: '2026-08-21-01',
    width: 6240,
    height: 4160,
    date: '2026-08-21',
    location: 'Walden, Colorado',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRoIAAABXRUJQVlA4IHYAAADwAwCdASoUAA0APt1cpkyopSOiMAgBEBuJQBdgBClRLiIxbRqFdUcAAPemSPjjCXHJ8Eyyrb9xcYNKCZEqvViJVPGZHo/NQsCRWanOA0lWNKIxvYQWGS3hIkNQLp9DoH98cmZKfbBZ687nRTAHOWV23saCruAA',
    v: '199ddc5062',
  },
  {
    slug: '2026-08-22-03',
    width: 6240,
    height: 4160,
    date: '2026-08-22',
    location: 'Orem, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpIAAABXRUJQVlA4IIYAAAAQBACdASoUAA0APt1apkyopSOiMAgBEBuJQBOmUABqjdPan6X+ZQt/AAD+x4CxhHn7K1fuaWft9MMtvHu7pg1wGiNN5Ig2xY59T53XyZxYhsbCF45KpBOXBCCrZ+SkVWiFYTdYvVNVKPVU752h77qNdDMycH+uGiRiJEpTQoDccohgqAAAAA==',
    v: 'daa68d3442',
  },
  {
    slug: '2026-08-30-01',
    width: 7803,
    height: 5875,
    date: '2026-08-30',
    location: 'Snowbird Ski Resort, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAABQBACdASoUAA8APt1apkyopSOiMAgBEBuJYgC7MoADUoCOGZlORHq1WC+gAN5VjlzhmNSke2TxeoRolk+ku7Mu+996nVIUKcnXa4xGN5Iy5ndRxGAw+hC9Xwgl0UBAa8ZGYLaQfGOmibGvvyp3vvxTgI9+o50Mi47I39/6J2cpaEhH4+HprnpyKwU2UDLWQz4QAA==',
    v: '4dad01639d',
  },
  {
    slug: '2026-09-05-02',
    width: 6240,
    height: 4160,
    date: '2026-09-05',
    location: 'Canyonlands National Park, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAAAQBACdASoUAA0APt1apkyopSOiMAgBEBuJQBOiP/wGzT539Sg53HTkAAD+7Y3KxzzZ6GSgFUNxkxXJO02QAvNtSyIUUj/4HY9YQ+OSgggcO90qPS8b/HTbw4tYAnO/8yYwl7zpK8QXCBAGbd9zgH/AjxECOAqUBtooNrigMQAAAA==',
    v: 'bd9ff81209',
  },
  {
    slug: '2026-08-22-02',
    width: 6240,
    height: 4160,
    date: '2026-08-22',
    location: 'Provo Canyon, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRqAAAABXRUJQVlA4IJQAAADwAwCdASoUAA0APt1cpkyopSOiMAgBEBuJQBdgBFJWDtMcDnjMeacAAM4pni2dBKGsWyMrWFNIUe0mJFMP+z0V/9dxzT8SUTntt8zfUZdJbEewluDN2bERvwE7Urvuuvap2udN6VjBONgu/eQF5qonf/EBmhCL8nkh7zVuLiBN1NByd4A/jdjl2T9jTZsS4trnCCAA',
    v: 'eadd75f682',
  },
  {
    slug: '2026-08-30-02',
    width: 8160,
    height: 6144,
    date: '2026-08-30',
    location: 'Wasatch National Forest, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABQBACdASoUAA8APt1cpkyopSOiMAgBEBuJQBOioAc/+A2gKsNt3vbErN0wAPzQ/3+5ZIxP0AGOl8NB0gwis2GB4YEWOEQqOFb6NIt/UQDrBseqEDJZSZOXh6b+J2HyuPS4+g1LE7r5pAAA',
    v: '2cebe836c1',
  },
  {
    slug: '2026-09-06-02',
    width: 4726,
    height: 3151,
    date: '2026-09-06',
    location: 'Canyonlands National Park, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRoYAAABXRUJQVlA4IHoAAACwAwCdASoUAA0APt1apkyopSOiMAgBEBuJQBOmUABbXuLnN8f6OAD+sj0aR/6foyq++J9R5jgQrg490AwcLfV4elEa5esaQLisz9F5+SE4RZB2lv5BdgPS27Wh+IzQZfegmvX34D8Icsk3cfDPdLPKyVzLZd+2n6VAAA==',
    v: '7860512e96',
  },
  {
    slug: '2024-05-21-01',
    width: 5158,
    height: 3439,
    date: '2024-05-21',
    location: 'Coconino National Forest, Arizona',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAADQAwCdASoUAA0APt1apkyopSOiMAgBEBuJZACdACHXTgWgH3s7/VgA/IyQJ0qnz8Db3SP6d6ZiCdqKW52pjl1SrYoMZ0o4dUv64LjyyZ2NkT6K/JxB6GWKhyXC7Q1/TagqrU1X4gAAAA==',
    v: '7497fef385',
  },
  {
    slug: '2024-05-20-01',
    width: 6168,
    height: 4112,
    date: '2024-05-20',
    location: 'Monument Valley, Utah',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRoIAAABXRUJQVlA4IHYAAAAQBACdASoUAA0APt1apkyopSOiMAgBEBuJbACdMoLT9A4hcjKyKaWdJAD6k7ozyI9dsxMGDpCt2vrGe04PAuuG3uCz9e2yQo0Qppzv1OnPlET91zHIeUBRILddf7Sz/rwVSrXYeHy+YFRc8Rtz4N5XzUTtFOAA',
    v: '47d93311b6',
  },
  {
    slug: '2022-10-10-01',
    width: 3200,
    height: 1800,
    date: '2022-10-10',
    location: 'Carbondale, Colorado',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpwAAABXRUJQVlA4IJAAAACQBACdASoUAAsAPt1apkyopSOiMAgBEBuJZgCdMoMYJn/AehXi0SUNPYSks3AA/iZv58R3Hrf26l0TtjSKAZClpAa6omMTe6GMkD16pZNfeufTOq/drKUd6h5xrL2F79efb2sWOScCzYtdkgC7q+6IgZi1QX975RfbolPw8J63pf1LeLg/yPiOQA4iNcoAAAA=',
    v: '0a8eb18e8e',
  },
  {
    slug: '2022-10-13-01',
    width: 3254,
    height: 1800,
    date: '2022-10-13',
    location: 'Garden of the Gods, Colorado',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpQAAABXRUJQVlA4IIgAAABQBACdASoUAAsAPt1apkyopSOiMAgBEBuJagCdICXgrxC8H4/xAOMFW14AAN5Xxp9wr0GklJaKJD/BYMLF5B4Lx4UWOk83nmTz+RyMIrn+BFINgo71mVxazJjB9pVmeYCDpxxzR/txSMSbHassC+rxsly0MOy3LublGhwi2EBZHqW2Qbl20YAA',
    v: '6789319b0d',
  },
  {
    slug: '2024-05-20-02',
    width: 6201,
    height: 4134,
    date: '2024-05-20',
    location: 'Coconino National Forest, Arizona',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAAAwBACdASoUAA0APt1apkyopSOiMAgBEBuJZACdACLLYT8a5+U3QMtthwAA/pvpwyw+39VyE8tbu0FK3Ef9w0VixMF5g4B6kNlMXhqkZ/MJ02LFvtTGJi5CHWDvuh6EkcsrSdDZUI4Mg4c8DYry+fPZEgvJ+yfGzXsQeA/QwaQeJN5v76LXi2d8rAAAAA==',
    v: '599f2b0118',
  },
  {
    slug: '2026-05-30-03',
    width: 3648,
    height: 2736,
    date: '2026-05-30',
    location: 'Black Hills, South Dakota',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpAAAABXRUJQVlA4IIQAAAAwBACdASoUAA8APt1apkyopSOiMAgBEBuJQBOmUGMACSwPB+6mjIMrIAAA/sYD5/1Yy0oJxCRYm2kbzJfL5exeDXpGl7Y7ZeWTuvToyxW5KfJynCnvTGXuIl6zlZsak5xyxM1E3JC0cyzreqw+LhV/zWoAt4SvvSA+TgtASOhUbf19UAA=',
    v: 'cb6de009a2',
  },
  {
    slug: '2026-05-30-01',
    width: 4898,
    height: 3265,
    date: '2026-05-30',
    location: 'Custer State Park, South Dakota',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnwAAABXRUJQVlA4IHAAAAAwBACdASoUAA0APt1apkyopSOiMAgBEBuJYwCdIHACuOwvDt3nSm28XQAA/shodC0R+mMVX0f77JeZpoZQAaJEoOmTvbZTETy5aSbOIIT4dg5l/96E5LhZckmByCkIleCHZEp4R67KYtdrrc66AAAA',
    v: 'dff3604950',
  },
  {
    slug: '2026-05-23-01',
    width: 4898,
    height: 3265,
    date: '2026-05-23',
    location: 'Mount Rushmore, South Dakota',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpoAAABXRUJQVlA4II4AAABQBACdASoUAA0APt1apkyopSOiMAgBEBuJYgCdEf/i15mVZlRzwp1Ro1owAN2TTSTuWOc0hmFLSW8xUudojL531j9KqiAMTkwi3M42sI4sJEQCVA2J6xHKn6UhaU4RgJXRmNQQcHoESfeE5wwJ42i8yJ/tek1j0I6Bv6oeL75ToMnoc1SwWPZO4eR8ITAA',
    v: '9ca6aa7e47',
  },
  {
    slug: '2026-05-14-01',
    width: 4898,
    height: 3265,
    date: '2026-05-14',
    location: 'Black Hills National Forest, South Dakota',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAAAQBACdASoUAA0APt1apkyopSOiMAgBEBuJZACdIIjDFGbnI6upbYAmwAD8+wqq7dVoV3wwu6ldm10G5yuKiuWa4S06YnpBEsQl9oUanyLQpF2rtl22Syhnad8B43Z7c3nTP5PQ/f81AJKyDIRnpEqhzzqEH5Mi+0e/CBYpFbtf9UelUFNW+oirpThpHq/7p9AAAA==',
    v: '0d95c2201c',
  },
  {
    slug: '2026-06-13-01',
    width: 6144,
    height: 5784,
    date: '2026-06-13',
    location: 'Black Hills, South Dakota',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRo4AAABXRUJQVlA4IIIAAAAQBQCdASoUABMAPt1gpk4opaMiKA1REBuJYwC/7BF2+/23fVMG4r3eSEJqaDDMDDGAAP7LVGl8v5nwigvtQAAO6Edj7VWh6tRKpcyjbqjq1ChiJjwY0vL2ntgXmtqPS+tYoVrnJTbYUlXsKQkOUgOeinAFbCR955tHQIhB4AAAAAAA',
    v: 'c5d0ea03d6',
  },
  {
    slug: '2026-06-05-01',
    width: 4898,
    height: 3265,
    date: '2026-06-05',
    location: 'Bighorn National Forest, Wyoming',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAADQAwCdASoUAA0APt1apkyopSOiMAgBEBuJQAALfDSg6SJaGtNS+gAA/ucoBjscSGuXJsDAf4xzeP1F2zLbFfayDzlunOJZuqr+hCUBn8ZgGasVf5pwmtIQFKgMgClQGKNT7XgAAAA=',
    v: '2966a25de9',
  },
  {
    slug: '2026-06-05-02',
    width: 4898,
    height: 3265,
    date: '2026-06-05',
    location: 'Bighorn National Forest, Wyoming',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRooAAABXRUJQVlA4IH4AAAAwBACdASoUAA0APt1apkyopSOiMAgBEBuJZQDCgCKbFTg8aE57aGfvjuAA/rYfxC9j22rttX8uG/WapOFuli1RhdHn0U0eZ36SRdc7Hay2/ayCzN7arbSlxfSlgOVUctR9IPw6fdAV1Dp85jrI0xJM77MBoBoBEOraTaGdAAA=',
    v: 'b87f5a1ea5',
  },
  {
    slug: '2026-05-23-02',
    width: 4898,
    height: 3265,
    date: '2026-05-23',
    location: 'Black Hills, South Dakota',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpIAAABXRUJQVlA4IIYAAADQAwCdASoUAA0APt1cpkyopSOiMAgBEBuJQBOkC5hgW7ah3A8x+2AA/rIyNNi5PcGfbYvc6vN1uar5s9MFwARpq87gVOt//Vo7gevtHl1qVhJqWqM+q6iwYUeDM8vUIAyDh3W2HX9ntzCpOuQPD6wtao7e6/9BF/R4y+ooHIzCJy/bIEkAAA==',
    v: '3aecfc1b0c',
  },
  {
    slug: '2026-05-30-02',
    width: 4898,
    height: 3265,
    date: '2026-05-30',
    location: 'Custer State Park, South Dakota',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRoYAAABXRUJQVlA4IHoAAADQAwCdASoUAA0APt1cpkyopSOiMAgBEBuJQBOgA9Bftmm0jte+iswA/FUNo0yCFVb8CVMnAuYm/SHpuqaZbDDrIJfimG0SpIxHAqE5p7/cTAIgnisCMAkiCOtdhhMEQR4xl/6eNSaqyKvuWeW2lPzzVm865ub+YxNAAA==',
    v: '547bbf54a4',
  },
  {
    slug: '2022-09-18-01',
    width: 2709,
    height: 1800,
    date: '2022-09-18',
    location: 'Grand Teton National Park, Wyoming',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAACwAwCdASoUAA0APt1ep00opSOiMAgBEBuJQBOmUABd5lWXLCqgYAD+Va6L1P1BeQJ8hXarWtCYLjTyx497e1ZOJ35b6W9+jgNaC+E/g2RJaghuk5QkMlzJjkUCQAAA',
    v: 'f3c6ad044e',
  },
  {
    slug: '2026-06-19-01',
    width: 6240,
    height: 3512,
    date: '2026-06-19',
    location: 'Wapsipinicon River, Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAAAQBACdASoUAAsAPt1apkyopSOiMAgBEBuJQBbZMXwcCll/ej2NvJv9sAD+5vIEGlN5VffijH8Jb953suDrvHShwX8oHn4sY2IkMVmWEvimOJkux1mupEI5YsDriFFGYZaenyT1eIJbIza8fYmMe/k6c9KJuFx8RNV+SwyTtsAAAA==',
    v: '2430c3475b',
  },
  {
    slug: '2026-07-22-01',
    width: 6240,
    height: 4160,
    date: '2026-07-22',
    location: 'Rural Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRngAAABXRUJQVlA4IGwAAAAwBACdASoUAA0APt1apkyopSOiMAgBEBuJZgC1CHACuOVZYF9m4/vD/AAA/f0jV/zE0vcZ9o2ULfSwsBtCC3eggEarIl+sr5fZ4GBxORFdnk3R8sZv1tAOws/7TVlCAVpTVCjjzlbNfIvFIAA=',
    v: '8f95347c49',
  },
  {
    slug: '2026-08-11-01',
    width: 6240,
    height: 4160,
    date: '2026-08-11',
    location: 'Redonkulous Farm, Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRoYAAABXRUJQVlA4IHoAAADQAwCdASoUAA0APt1cpkyopSOiMAgBEBuJaACsABelwWN92DgXfzAA/lv+ml0Fydg5fGBDq/+P2z3YV9/U/HfWegROSp0WGFACVz84cFtsHQ2wIadNvq5hX05boBk0+g/gfbitY6lo3OLLJIAYN649Y6RY2QPBOvUAAA==',
    v: 'cd69ac7110',
  },
  {
    slug: '2026-08-11-03',
    width: 6240,
    height: 4160,
    date: '2026-08-11',
    location: 'Rural Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRo4AAABXRUJQVlA4IIIAAAAwBACdASoUAA0APt1apkyopSOiMAgBEBuJYgCdAYwS1T5gNggSf24EAmIA/e2EWkaytx7ECHBYcy+SJJO5BN4bpy1o3d0BvMwD6xy9uQRuBtebcyAmHRZfFkPNV1dR/4a4jb+TbUC13hcaeN9mMDEclYZPoOlC0jhO92XQSppIVgAA',
    v: 'ae9766ded0',
  },
  {
    slug: '2026-07-25-01',
    width: 3098,
    height: 2736,
    date: '2026-07-25',
    location: 'Field of Dreams, Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRsoAAABXRUJQVlA4IL4AAACQBACdASoUABIAPt1mqlEopSOiqAgBEBuJQAECADKYENM9yRoQ8WH7wPt4w7AA/u3ds/mcpllLemHyR0ivaDsf4R3TI955PZOgE/vJzHJrMj6Euh7wtk1md2lIOwns+hjm4iNatpgQfggN535/bO71leHxi0z2EzvLfSpnIU9rWs1SUbeFHBKG8YIDRmNbi4OJx61Xc2p1ewJ8UQu9hNYS8mK8vW7R1qwNCqPvsYyM3CCE/h4Cz1sM0lRDAAAA',
    v: '1c2a03e993',
  },
  {
    slug: '2026-07-23-01',
    width: 3648,
    height: 2736,
    date: '2026-07-23',
    location: 'A Level B road, Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAAAwBACdASoUAA8APt1apkyopSOiMAgBEBuJYgCdMoMzGEPqjvvdHsYYNAAA/sXl23hecl3vvg9zs69c8c9XXc9l3vIZrlr20HKMzKCygRiu7Ea+3nuS+/Ye1FkbUWtNpag/tCwVNrggMwv6r/H91GvtnSUQ4wHIhr0mEhkjOt7T0RTxFHlAoUmQbh5i+BZfeTAAAA==',
    v: '17e547bce9',
  },
  {
    slug: '2024-05-05-01',
    width: 4898,
    height: 3265,
    date: '2024-05-05',
    location: 'Rural Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpAAAABXRUJQVlA4IIQAAADwAwCdASoUAA0APt1cpkyopSOiMAgBEBuJQBOgMYdXPfkVJMDGKvNwAP7t2TDJ2174kiJcnOMeKaIvWD9zFnWBUPdEUW3djjhJexZDYBS5bo1q2200tjpIR+Hh8zRXko4gTmUiZKJOicbR+Awp7a9nFDjfPIEIp23vZX5UQC7fMDmAAAA=',
    v: '3c167d091e',
  },
  {
    slug: '2026-07-23-02',
    width: 6240,
    height: 4160,
    date: '2026-07-23',
    location: 'Rural Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRqYAAABXRUJQVlA4IJoAAADQAwCdASoUAA0APt1apkyopSOiMAgBEBuJbACxDExCdHrOCS6HqpAA/udWh8/TE4D5SVU7FD7FLQkqPdA1SXlIKltLHEifJKtHHrb/m09lr/jPmiSr+nSSkQ0O1fzQ9RA/o6ZeTnXOZKl0tRfxiD8eJJdAEJE2kIcyFJRE4GHFdWEHzEFxZJE0nYeMDbKaCguSdl8C+QjAAAAA',
    v: 'bea60a1b85',
  },
  {
    slug: '2026-08-11-02',
    width: 4511,
    height: 3443,
    date: '2026-08-11',
    location: 'Redonkulous Farm, Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpYAAABXRUJQVlA4IIoAAABwBACdASoUAA8APt1apkyopSOiMAgBEBuJZACdAdwA3B6jLYHWai4Fz8kh8AD+7/wIyZlWZ60yoLU4Qiz8yc6AKxuco5blvjRJPLLAl85+853/1XYQ0EUTP1WjFu0ZlHJucvf/hKF2fxosuXyGzVJc7KOkZoiSXfLhGX1+zydjjM0x1p4vKZ8AAAA=',
    v: 'b88996bf0c',
  },
  {
    slug: '2021-10-15-01',
    width: 4000,
    height: 3000,
    date: '2021-10-15',
    location: 'Secret Fishing Spot, Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAACwBACdASoUAA8APt1apkyopSOiMAgBEBuJYwCdMoMnJ0kVdCTUxgOBU37NnPqUAP4ChOG7EW/Cg1ja4TZnadOEKYaKDZB5p8rM1fXetWe0diq2+SeXG9129cSja68z8Ylu10N6SMKtx7qeIKCZrFgx5GM/JpTLamDfoaKfnXN+99oCXBCoQwecsW4q5uwaH4AAAA==',
    v: 'f339afc285',
  },
  {
    slug: '2026-07-08-02',
    width: 4898,
    height: 3265,
    date: '2026-07-08',
    location: 'Great Smoky Mountains National Park',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpQAAABXRUJQVlA4IIgAAADwAwCdASoUAA0APt1apkyopSOiMAgBEBuJYgCdIKnBynVypj1BNX4AAP7TXNv5+juuKXp+XxYNiQxyDVvDwmq1YA5nd/XaH6Ott84v2AApVYK9G6RHgalTfMG9iZWNcJOeFOXvZz35VOX/6Ewe2qzce3GQukMy52f6vihnk6Vlb7nqLFnqAAAA',
    v: 'efab15ce40',
  },
  {
    slug: '2025-08-30-01',
    width: 6240,
    height: 4160,
    date: '2025-08-30',
    location: 'Paradise, Michigan',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAADwAwCdASoUAA0APt1cpkyopSOiMAgBEBuJZQDCgCLJ5AcStsBsaR9AAPR2U2ga5UWGPi5Oo5AcrdJg/z3HrKBUU3owmc++4IBNIG3Kdzd+KLvetxB95TPQhE2Y2B5qGg7cOgjaxz+5FV+fmdt69cY3BlehVmkl0i1YWo33Z6HwAA==',
    v: 'f0aa63cdfe',
  },
  {
    slug: '2026-07-08-01',
    width: 5331,
    height: 3000,
    date: '2026-07-08',
    location: 'Great Smoky Mountains National Park',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAACQBACdASoUAAsAPt1cpkyopSOiMAgBEBuJQBahG0dAc/+BAd+JgBkX2s5sEyAA/NlTW72zIbKfxDofYaXEjuu9Lt9i8XkRte5/QIVu1gZ7O7TmnWrTM8P7ozgKcH//NSz5RDuKZOl9VQcyMc8oK4UMrIUHEc/E5AwYAAAA',
    v: '7e8f107cc9',
  },
  {
    slug: '2025-08-30-02',
    width: 6240,
    height: 4160,
    date: '2025-08-30',
    location: 'Tahquamenon Falls State Park, Michigan',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRowAAABXRUJQVlA4IIAAAAAQBACdASoUAA0APt1cpkyopSOiMAgBEBuJZQCo9CLMJ7ncMr4WYhzxQAD+6//E1ATUE36FsHJIJudFaMRZ9TCUh6uhiY0sebAfPCHnSyk1C0B/SEM3KTWaDEciCQfNpunA5xAfRYnDbSwqKN2xjyHS2pFUcfFL/RLDbtcyUuF0AA==',
    v: 'b2e25fbdd0',
  },
  {
    slug: '2025-04-29-01',
    width: 4898,
    height: 3265,
    date: '2025-04-29',
    location: 'My Parents’ Place',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRqYAAABXRUJQVlA4IJoAAAAwBACdASoUAA0APt1apkyopSOiMAgBEBuJZAC7AYyAyQuydkJSxPf5EOAA/ufiVyzyupMAHTzLEDfSZZgYQjG40bO5O7NzUKbg/vywRFj2XvcU+3Jvdo4t86jzBHhVW6/PpmWERIDvDNpsuwbiLDMigzy5S+oCBM5xhvqS4/UFZ4qoLjSBbWMzWwF/T/zsKMQ4HvD6dqYcAAAA',
    v: 'cbb2488e6e',
  },
  {
    slug: '2025-11-11-01',
    width: 4080,
    height: 3072,
    date: '2025-11-11',
    location: 'A Cemetery, Iowa',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRogAAABXRUJQVlA4IHwAAAAQBACdASoUAA8APt1cpkyopSOiMAgBEBuJbAAAYcxO8l1lUfGLb1H4gAD+8tk5codNMqIx3CzCvGbEHKD444thNSBlYL37tFF136ikirx0YZf+1grCa/sMBUDUoNLmsS8pcU5Fnqw7fInJIQeK/5f5JrAKl/puV1xRwAAA',
    v: 'f87b3e7c8a',
  },
  {
    slug: '2024-05-03-01',
    width: 6240,
    height: 4160,
    date: '2024-05-03',
    location: 'My Parents’ Place',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRpoAAABXRUJQVlA4II4AAADQAwCdASoUAA0APt1apkyopSOiMAgBEBuJYgAAQtMORTTBoDuZG0AA+XhaR+yr7mEb1UMsSCuwfyRY91pmjd5WuB2UJ14oR0ydTm0WWsUog1zmJvoKb3qy5l/IlxrACl2ydtjMXfqE8Pp1RAN958rru8iJ+9VZTFBVBgUuAxylxonLVhUPQ+h6IjgAuAAA',
    v: '414df30a12',
  },
  {
    slug: '2024-05-03-02',
    width: 5984,
    height: 4027,
    date: '2024-05-03',
    location: 'My Parents’ Place',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAADwAwCdASoUAA0APt1cp0yopSOiMAgBEBuJYwDE2CHfU+vDox34H3eAAP7zeEunbYQrcOGnEjhxRUqwWuESdxDtPKVI9TKqoiXnStcBHG9hZkhlv+WFcYxwGZ+h6NgA',
    v: 'fac21fddd0',
  },
  {
    slug: '2024-05-16-01',
    width: 4898,
    height: 3265,
    date: '2024-05-16',
    location: 'My Parents’ Place',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRrAAAABXRUJQVlA4IKQAAADwBACdASoUAA0APt1apkyopSOiMAgBEBuJbACsFQA5/8WwmtrF86PobLm+9dBWggAA/iTHtfdfUNhkgqny7hms1E7BKogg9CTFsIuny/p1InC5JFp5UM20/3O4/21KE7RnBMgSIQGVBdPAL+T1vHb82hAcDvfMb976afr648EnE0e/E77LN+kHpBsRUDHIkvD5qdD71HAKYcQ1cSdTUXN/hYgAAA==',
    v: '15810acf7f',
  },
  {
    slug: '2025-02-26-04',
    width: 6146,
    height: 4098,
    date: '2025-02-26',
    location: 'Padre Island National Seashore, Texas',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAAAQBACdASoUAA0APt1cpkyopSOiMAgBEBuJZQCw7CG7rCMCbeNOHT13oAD+kXH0UZn5soTcIe4E4xdaR3fywte1NT4G9b+/u456YKDlmE78JkgtDVxBhR+TImyXVqgAAAA=',
    v: '3318b39c37',
  },
  {
    slug: '2025-02-26-03',
    width: 4993,
    height: 3329,
    date: '2025-02-26',
    location: 'Port Aransas, Texas',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAACwAwCdASoUAA0APt1apkyopSOiMAgBEBuJYgCdABuO/fIUndqpAAD8ge5O4HsJZ95KbYFtOfEcJaM+HZOQHQ9l8ZoeopqpNWn+RXQVKQlgYC64laBQAAAA',
    v: '9096e54291',
  },
  {
    slug: '2025-02-26-01',
    width: 4898,
    height: 3265,
    date: '2025-02-26',
    location: 'Aransas Pass, Texas',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRq4AAABXRUJQVlA4IKIAAABQBACdASoUAA0APt1apkyopSOiMAgBEBuJQBadMX6asEusnxeMwzygrMAAAP7p+PJbPjgbrWEXZ4W8QusaNoE0xnjwnUn5V8Yo+2+BrQUMrjgjAG50c0RSWp2G3H1XtLo7E4YKP9HF2t4qPMAI0h3frYf45vj6x+B39u5gEXz2McdOA+s26H5pqa/EGxh6ih/4kmDR85QfSmU58Pos3nTYAAA=',
    v: '6847ab285e',
  },
  {
    slug: '2025-02-26-02',
    width: 6024,
    height: 4017,
    date: '2025-02-26',
    location: 'Port Aransas, Texas',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRn4AAABXRUJQVlA4IHIAAADQAwCdASoUAA0APt1cpkyopSOiMAgBEBuJYgCdACPq3mpTcykwzAAA/sAdvVwODHJFHa+3kPomtf113FmN//Gc0ZKDDnf4O/ZeSKrpdEy9qjPjNJlEI+n/QFBFalrqXt9r+zyi9R1KTGu2I63ocD8YAAA=',
    v: 'bf476f6888',
  },
  {
    slug: '2025-03-07-02',
    width: 6240,
    height: 4160,
    date: '2025-03-07',
    location: 'Norwood, Colorado',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRnwAAABXRUJQVlA4IHAAAACwAwCdASoUAA0APt1cp0yopSOiMAgBEBuJQBWEBshgTe120P9BgAD8fckZOXMitVRntPipLK6M7fmIUV6UvM1HFrUh6GNWssarVqd8QoVBUZbLxphnNyEq01Lm3tpRkfATCsuv4D47bPqdWepCIAAA',
    v: 'e8876ef89f',
  },
  {
    slug: '2025-03-02-01',
    width: 6240,
    height: 4160,
    date: '2025-03-02',
    location: 'San Juan Mountains, Colorado',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRoYAAABXRUJQVlA4IHoAAAAQBACdASoUAA0APt1cpkyopSOiMAgBEBuJaACdACPttyDW8csXE/aPgAD8gDGIvBVLyV+ouQrJPSUwBLjgvtpjc91mFcMWFKajZ/yvckxfZQGvMONI0DVDOJr+Dz8hxTX0Ksn6/IYS4JAr48/YnqtCZIL5sc5rRigAAA==',
    v: '4a2aa00138',
  },
  {
    slug: '2025-03-07-01',
    width: 6240,
    height: 4160,
    date: '2025-03-07',
    location: 'Norwood, Colorado',
    caption: '',
    lqip: 'data:image/webp;base64,UklGRooAAABXRUJQVlA4IH4AAADwAwCdASoUAA0APt1cp0yopSOiMAgBEBuJZQCdACLWpa457jB/OesAAP7qpsXLivW27g36cxvA7f84BfNPb7dafPN5WGxLdkzeuibyDwTq8t974J/UGI5MEmgyBRbsdDZaaXDLpSLaFov0/k4dn3IbkPDG/SEq0MXljoHMwAA=',
    v: '5e202486e4',
  },
]
